import React from 'react';
import { Box, Typography } from '@mui/material';

// Tarjeta contenedora de graficos/listas del Dashboard — ver
// design_handoff_crediapp_redesign/Dashboard CrediApp.dc.html:
// radio 16px, padding 22px, titulo Poppins 600 16.5px y subtitulo 13px faint.
// `right` es el bloque opcional alineado a la derecha del encabezado.
const SectionCard = ({ title, subtitle, right, children, sx }) => (
	<Box
		sx={{
			backgroundColor: 'background.paper',
			border: '1px solid',
			borderColor: 'divider',
			borderRadius: '16px',
			padding: '22px',
			...sx
		}}
	>
		<Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px' }}>
			<Box sx={{ minWidth: 0 }}>
				<Typography sx={{ fontFamily: "'Poppins', sans-serif", fontWeight: 600, fontSize: 16.5, color: 'text.primary' }}>
					{title}
				</Typography>
				{subtitle ? <Typography sx={{ fontSize: 13, color: 'text.disabled', marginTop: '3px' }}>{subtitle}</Typography> : null}
			</Box>
			{right}
		</Box>
		{children}
	</Box>
);

export default SectionCard;
